import { render, staticRenderFns } from "./button-group.vue?vue&type=template&id=d7c85354&"
import script from "./button-group.vue?vue&type=script&lang=js&"
export * from "./button-group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d7c85354')) {
      api.createRecord('d7c85354', component.options)
    } else {
      api.reload('d7c85354', component.options)
    }
    module.hot.accept("./button-group.vue?vue&type=template&id=d7c85354&", function () {
      api.rerender('d7c85354', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "themes/default/src/components/button-group/button-group.vue"
export default component.exports